import PrincipalEditorSmsSetting from './principal-editor-smssetting';

export default PrincipalEditorSmsSetting;